(function(){
if(window.__ftrInit)return;window.__ftrInit=true;
var reduce=window.matchMedia&&matchMedia('(prefers-reduced-motion: reduce)').matches;
function mark(){document.querySelectorAll('.ftr').forEach(function(r){r.classList.add('is-js');});}
mark();document.addEventListener('shopify:section:load',mark);
function pick(model,motivo){var f=document.getElementById('fjd-trion-form');if(!f)return;
 function setSel(name,val){var s=f.querySelector('[name="'+name+'"]');if(!s||!val)return;for(var i=0;i<s.options.length;i++){if(s.options[i].value===val){s.selectedIndex=i;return;}}}
 setSel('contact[Equipo]',model);setSel('contact[Motivo]',motivo);}
document.addEventListener('click',function(e){
 var a=e.target.closest('[data-fjd-model],[data-fjd-motivo]');
 if(a){pick(a.getAttribute('data-fjd-model'),a.getAttribute('data-fjd-motivo'));var t=document.getElementById('fjd-contacto');
  if(t){e.preventDefault();t.scrollIntoView({behavior:reduce?'auto':'smooth',block:'start'});try{history.replaceState(null,'','#fjd-contacto');}catch(_){}
   setTimeout(function(){var n=document.getElementById('fjd-name');if(n)n.focus({preventScroll:true});},reduce?0:500);}return;}
 var fb=e.target.closest('[data-ftr-filters] button[data-filter]');
 if(fb){var bar=fb.closest('[data-ftr-filters]');var grid=document.getElementById(bar.getAttribute('data-ftr-filters'));var f=fb.getAttribute('data-filter');
  bar.querySelectorAll('button').forEach(function(x){x.setAttribute('aria-pressed',x===fb?'true':'false');});
  if(grid)grid.querySelectorAll('[data-cat]').forEach(function(c){c.hidden=!(f==='all'||(' '+c.getAttribute('data-cat')+' ').indexOf(' '+f+' ')>-1);});return;}
 var vb=e.target.closest('.ftr-video__play');
 if(vb){var w=vb.closest('[data-ftr-video]');var v=w&&w.querySelector('video');if(v){w.classList.add('is-playing');var p=v.play();if(p&&p.catch)p.catch(function(){});v.focus();}return;}
 var yb=e.target.closest('[data-yt]');
 if(yb){var id=yb.getAttribute('data-yt');var box=yb.closest('.ftr-yt__media');var i=document.createElement('iframe');
  i.src='https://www.youtube-nocookie.com/embed/'+encodeURIComponent(id)+'?autoplay=1&rel=0';i.title=yb.getAttribute('data-title')||'Vídeo';
  i.allow='accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';i.setAttribute('allowfullscreen','');i.loading='lazy';
  box.innerHTML='';box.appendChild(i);return;}
});
document.addEventListener('play',function(e){var w=e.target.closest&&e.target.closest('[data-ftr-video]');if(w)w.classList.add('is-playing');},true);
try{var q=new URLSearchParams(location.search).get('modelo');if(q)document.addEventListener('DOMContentLoaded',function(){pick(q);});}catch(_){}

/* video con reproduccion al hacer scroll */
function ftrAV(w){
 if(w.__av)return; w.__av=1;
 var v=w.querySelector('video'); if(!v)return;
 var bp=w.querySelector('.vplay'), bt=w.querySelector('[data-act=toggle]'), bm=w.querySelector('[data-act=mute]');
 var userPaused=false;
 v.removeAttribute('controls'); v.muted=true; w.classList.add('av-ready','is-muted');
 function labels(){ if(bt)bt.setAttribute('aria-label', v.paused?'Reproducir vídeo':'Pausar vídeo'); if(bm)bm.setAttribute('aria-label', v.muted?'Activar sonido':'Silenciar vídeo'); }
 function play(){ if(v.preload==='none')v.preload='auto'; var p=v.play(); if(p&&p.catch)p.catch(function(){}); }
 v.addEventListener('play',function(){w.classList.add('is-playing');labels();});
 v.addEventListener('pause',function(){w.classList.remove('is-playing');labels();});
 if(bp)bp.addEventListener('click',function(){userPaused=false;play();});
 if(bt)bt.addEventListener('click',function(){ if(v.paused){userPaused=false;play();}else{userPaused=true;v.pause();} });
 v.addEventListener('click',function(){ if(v.paused){userPaused=false;play();}else{userPaused=true;v.pause();} });
 if(bm)bm.addEventListener('click',function(){ v.muted=!v.muted; w.classList.toggle('is-muted',v.muted); if(!v.muted&&v.paused){userPaused=false;play();} labels(); });
 labels();
 if(!reduce && 'IntersectionObserver' in window){
  new IntersectionObserver(function(es){ es.forEach(function(e){
   if(e.isIntersecting && e.intersectionRatio>=0.5){ if(!userPaused && v.paused) play(); }
   else if(!v.paused){ v.pause(); }
  }); },{threshold:[0,0.5]}).observe(w);
 }
}
function ftrAVall(){ document.querySelectorAll('[data-ftr-autovideo]').forEach(ftrAV); }
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',ftrAVall); else ftrAVall();
})();


/* ftrProg: barra de progreso y tiempo en los vídeos [data-ftr-autovideo] */
(function(){
  function fmt(s){s=Math.max(0,Math.floor(s||0));return Math.floor(s/60)+':'+String(s%60).padStart(2,'0');}
  function ftrProg(w){
    if(w.__ftrProg)return; var v=w.querySelector('video'); if(!v)return; w.__ftrProg=1;
    var bar=document.createElement('div'); bar.className='vprog'; bar.setAttribute('aria-hidden','true');
    bar.style.cssText='position:absolute;left:0;right:0;bottom:0;height:5px;background:rgba(255,255,255,.25);z-index:3;pointer-events:none';
    var fill=document.createElement('i'); fill.style.cssText='display:block;height:100%;width:0;background:#FFD333;transition:width .25s linear';
    bar.appendChild(fill); w.appendChild(bar);
    var t=document.createElement('span'); t.className='vtime'; t.setAttribute('aria-hidden','true');
    t.style.cssText='display:inline-flex;align-items:center;height:44px;padding:0 14px;border-radius:99px;background:rgba(17,17,17,.75);color:#fff;font:600 13px/1 inherit;font-variant-numeric:tabular-nums;white-space:nowrap';
    t.textContent='0:00';
    var vb=w.querySelector('.vbar'); if(vb) vb.insertBefore(t, vb.firstChild);
    var last=0;
    function upd(){
      var d=v.duration; if(!d||!isFinite(d))return;
      var c=v.currentTime, p=Math.min(100,c/d*100);
      fill.style.transition = c<last ? 'none' : 'width .25s linear';
      fill.style.width=p+'%'; last=c;
      t.textContent=fmt(c)+' / '+fmt(d);
    }
    v.addEventListener('timeupdate',upd); v.addEventListener('loadedmetadata',upd); v.addEventListener('seeked',upd);
  }
  function init(){ document.querySelectorAll('[data-ftr-autovideo]').forEach(ftrProg); }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init); else init();
  document.addEventListener('shopify:section:load',init);
})();
